import { MUISECONDARYCOLOR } from "../../../constants/mui-styles-constant";

export const mobSidebarDrawer = {
    display: { xs: "flex", sm: "none" }, width: "265px", overflow: 'hidden', '& .MuiDrawer-paper':
        { overflow: 'hidden', background: MUISECONDARYCOLOR, }
}